import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, ToastController, LoadingController, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';

export interface FileType {
  extension: string;
  selected: boolean;
  src: string;
  srcSelected: string;
}

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  public loading: HTMLIonLoadingElement;

  constructor(private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private platform: Platform,
    private toast: ToastController,
    private storage: Storage) { }


  /**
   * Muestra loading
   * @param message Mensaje del loading (opcional)
   */
  async showLoading(message?: string, duration?: number) {
    this.loading = await this.loadingCtrl.create({
      message: message ? message : null,
      duration: duration ? duration : null
    });
    return this.loading.present();
  }

  /**
   * Quita el loading cargado (arreglado)
   */
  public dismissLoading() {
    if (this.loading) {
      return this.loading.dismiss();
    }
    return Promise.resolve(true);
  }

  /**
   * Devuelve el sistema operativo del dispositivo
   */
  public getPlatform() {
    return this.platform.is('ios') ? 'ios' : 'android';
  }

  /**
   * Devuelve el nombre del archivo pasado (incluida la extensión)
   * @param path Ruta del archivo
   */
  public getFileName(path: string) {
    return path.split('/').pop();
  }

  /**
   * Devuelve la extensión del archivo pasado
   * @param path Ruta del archivo
   */
  public getFileExtension(path: string) {
    return path.split('.').pop().toLowerCase();
  }

  /**
   * Muestra un alert genérico para notificar algo (un error, éxito, etc)
   * @param title Título del alert
   * @param message Mensaje del alert
   */
  public async showAlert(title: string, message: string, backdropDismiss = true) {
    let alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: ['OK'],
      backdropDismiss: backdropDismiss
    });

    alert.present();
  }

  /**
   * Muestra un toast genérico para notificar algo (un error, éxito, etc)
   * @param message Mensaje del toast
   */
  public async showToast(message: string) {
    const toast = await this.toast.create({
      message: message,
      duration: 5000,
      buttons: ['OK']
    });
    toast.present();
  }

  public capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * Returns an array containing the total errors of an HTTP request.
   * @param httpErrorResponse HTTP response error.
   */
  public getArrayOfHttpErrors(httpErrorResponse: HttpErrorResponse) {
    const keys = Object.keys(httpErrorResponse.error.errors);
    const errorMessages: string[] = [];
    for (const key of keys) {
      for (const error of httpErrorResponse.error.errors[key]) {
        errorMessages.push(error);
      }
    }
    return errorMessages;
  }

  /**
   * Handles a HTTP response error showing a helpful report.
   * @param httpErrorResponse HTTP response error.
   */
  public handleHttpErrorResponse(httpErrorResponse: HttpErrorResponse) {
    const errors = this.getArrayOfHttpErrors(httpErrorResponse);
    if (errors.length > 0) {
      this.showToast(errors[0]);
    }
    else {
      this.showToast('Ocurrió un error desconocido al hacer la petición');
    }
  }

  getAvailableFileTypes() {
    const fileTypes: FileType[] = [
      {
        extension: 'pdf',
        selected: false,
        src: 'assets/icon/files-bar/pdf.png',
        srcSelected: 'assets/icon/files-bar/white-pdf.png',
      },
      {
        extension: 'jpg',
        selected: false,
        src: 'assets/icon/files-bar/jpg.png',
        srcSelected: 'assets/icon/files-bar/white-jpg.png',
      },
      {
        extension: 'png',
        selected: false,
        src: 'assets/icon/files-bar/png.png',
        srcSelected: 'assets/icon/files-bar/white-png.png',
      },
      {
        extension: 'docx',
        selected: false,
        src: 'assets/icon/files-bar/word.png',
        srcSelected: 'assets/icon/files-bar/white-word.png',
      },
      {
        extension: 'xlsx',
        selected: false,
        src: 'assets/icon/files-bar/excel.png',
        srcSelected: 'assets/icon/files-bar/white-excel.png',
      },
    ];
    return fileTypes;
  }

  /**
   * Devuelve un array con los nombres y archivos de los iconos de alérgenos
   * @returns Array con los nombres y archivos de los iconos de alérgenos
   */
  getAllergenAvailableIcons() {
    return [
      {
        name: 'altramuces',
        filePath: 'altramuces.svg'
      },
      {
        name: 'apio',
        filePath: 'apio.svg'
      },
      {
        name: 'cacahuetes',
        filePath: 'cacahuetes.svg'
      },
      {
        name: 'cascara',
        filePath: 'cascara.svg'
      },
      {
        name: 'gluten',
        filePath: 'gluten.svg'
      },
      {
        name: 'huevo',
        filePath: 'huevo.svg'
      },
      {
        name: 'lactosa',
        filePath: 'lactosa.svg'
      },
      {
        name: 'moluscos',
        filePath: 'moluscos.svg'
      },
      {
        name: 'mostaza',
        filePath: 'mostaza.svg'
      },
      {
        name: 'pescado',
        filePath: 'pescado.svg'
      },
      {
        name: 'sesamo',
        filePath: 'sesamo.svg'
      },
      {
        name: 'soja',
        filePath: 'soja.svg'
      },
      {
        name: 'sulfitos',
        filePath: 'sulfitos.svg'
      },
    ];
  }
}